import React, { createContext, useContext } from "react";
import { useJsApiLoader } from "@react-google-maps/api";
import { GOOGLE_MAPS_API_KEY } from "../constant";

const GOOGLE_MAPS_LIBRARIES = ["marker"];

const GOOGLE_MAPS_LOADER_OPTIONS = {
  id: "ambumedik-google-map-script",
  googleMapsApiKey: GOOGLE_MAPS_API_KEY,
  language: "es",
  libraries: GOOGLE_MAPS_LIBRARIES,
};

const GoogleMapsContext = createContext({
  isLoaded: false,
  loadError: null,
});

const GoogleMapsLoader = ({ children }) => {
  const { isLoaded, loadError } = useJsApiLoader(GOOGLE_MAPS_LOADER_OPTIONS);

  return (
    <GoogleMapsContext.Provider value={{ isLoaded, loadError }}>
      {children}
    </GoogleMapsContext.Provider>
  );
};

export const GoogleMapsProvider = ({ children }) => {
  if (!GOOGLE_MAPS_API_KEY) {
    return (
      <GoogleMapsContext.Provider
        value={{
          isLoaded: false,
          loadError: new Error("Google Maps API key no configurada"),
        }}
      >
        {children}
      </GoogleMapsContext.Provider>
    );
  }

  return <GoogleMapsLoader>{children}</GoogleMapsLoader>;
};

export const useGoogleMaps = () => {
  return useContext(GoogleMapsContext);
};
